export const SS_KEY = {
	AUTH_TOKEN: 'SS_KEY_AUTH_TOKEN',
	USER: 'SS_KEY_USER',
	APP_SLUG: 'SS_KEY_APP_SLUG'
};

/* General */
export const RESET = 'RESET';
export const RESET_ALERT_MESSAGE = 'RESET_ALERT_MESSAGE';
export const UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';

/* auth-bigcommerce-page */
export const GET_BIGCOMMERCE_OAUTH_URL = 'GET_BIGCOMMERCE_OAUTH_URL';
export const ERROR_BIGCOMMERCE_OAUTH_URL = 'ERROR_BIGCOMMERCE_OAUTH_URL';

/* auth-shopify-page */
export const GET_SHOPIFY_OAUTH_URL = 'GET_SHOPIFY_OAUTH_URL';
export const ERROR_SHOPIFY_OAUTH_URL = 'ERROR_SHOPIFY_OAUTH_URL';

/* callback-shopify-page */
export const LOGIN_SHOPIFY = 'LOGIN_SHOPIFY';
export const ERROR_SHOPIFY_LOGIN = 'ERROR_SHOPIFY_LOGIN';

/* dashboard-customer-emails-page */
export const DOWNLOAD_CUSTOMER_EMAIL = 'DOWNLOAD_CUSTOMER_EMAIL';
export const GET_SHOPIFY_APP_CONNECTION = 'GET_SHOPIFY_APP_CONNECTION';
export const ERROR_DOWNLOAD_CUSTOMER_EMAIL = 'ERROR_DOWNLOAD_CUSTOMER_EMAIL';
export const ERROR_GET_SHOPIFY_APP_CONNECTION = 'ERROR_GET_SHOPIFY_APP_CONNECTION';

/* dashboard-emails-activity-page */
export const DOWNLOAD_CUSTOMER_EMAIL_EVENT = 'DOWNLOAD_CUSTOMER_EMAIL_EVENT';
export const ERROR_DOWNLOAD_CUSTOMER_EMAIL_EVENT = 'ERROR_DOWNLOAD_CUSTOMER_EMAIL_EVENT';

/* dashboard-settings-page */
export const GET_ABANDONED_CART_TEMPLATE_CONNECTIONS = 'GET_ABANDONED_CART_TEMPLATE_CONNECTIONS';
export const UPDATE_TEMPLATE_CONNECTIONS = 'UPDATE_TEMPLATE_CONNECTIONS';
export const RENDER_ABANDONED_CART_EMAIL_TEMPLATE = 'RENDER_ABANDONED_CART_EMAIL_TEMPLATE';
export const ERROR_RENDER_ABANDONED_CART_EMAIL_TEMPLATE = 'ERROR_RENDER_ABANDONED_CART_EMAIL_TEMPLATE';
export const GET_ABANDONED_CART_TEMPLATE_CONNECTION = 'GET_ABANDONED_CART_TEMPLATE_CONNECTION';
export const ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION = 'ERROR_GET_ABANDONED_CART_TEMPLATE_CONNECTION';
export const UPDATE_TEMPLATE_CONNECTION_BY_ID = 'UPDATE_TEMPLATE_CONNECTION_BY_ID';
export const ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID = 'ERROR_UPDATE_TEMPLATE_CONNECTION_BY_ID';
export const UPDATE_SAMPLE_EMAIL_RECIPIENT_EMAIL = 'UPDATE_SAMPLE_EMAIL_RECIPIENT_EMAIL';
export const SEND_SAMPLE_EMAIL = 'SEND_SAMPLE_EMAIL';
export const UPDATE_FORM_FIELD_FOR_GENERAL_SETTINGS_PAGE = 'UPDATE_FORM_FIELD_FOR_GENERAL_SETTINGS_PAGE';
export const GET_IN_PROGRESS_PAYMENTS = 'GET_IN_PROGRESS_PAYMENTS';
export const ERROR_GET_IN_PROGRESS_PAYMENTS = 'ERROR_GET_IN_PROGRESS_PAYMENTS';

export const OPTION_FIRST_EMAIL_SENDOUT_DELAY = [
	{key: '0.25', text: '15 minutes', value: '0.25'},
	{key: '0.5', text: '30 minutes', value: '0.5'},
	{key: '0.75', text: '45 minutes', value: '0.75'},
	{key: '1', text: '1 hour(Recommeneded)', value: '1'},
	{key: '2', text: '2 hours', value: '2'},
	{key: '3', text: '3 hours', value: '3'},
	{key: '4', text: '4 hours', value: '4'},
	{key: '8', text: '8 hours', value: '8'},
	{key: '12', text: '12 hours', value: '12'},
	{key: '24', text: '1 day', value: '24'},
	{key: '36', text: '1.5 days', value: '36'},
	{key: '48', text: '2 days', value: '48'},
	{key: '72', text: '3 days', value: '72'},
	{key: '96', text: '4 days', value: '96'},
	{key: '120', text: '5 days', value: '120'},
	{key: '144', text: '6 days', value: '144'},
	{key: '168', text: '7 days', value: '168'}
];
export const OPTION_SECOND_EMAIL_SENDOUT_DELAY = [
	{key: '1', text: '1 hour', value: '1'},
	{key: '2', text: '2 hours', value: '2'},
	{key: '3', text: '3 hours', value: '3'},
	{key: '4', text: '4 hours', value: '4'},
	{key: '8', text: '8 hours', value: '8'},
	{key: '12', text: '12 hours', value: '12'},
	{key: '24', text: '1 day (Recommended)', value: '24'},
	{key: '36', text: '1.5 days', value: '36'},
	{key: '48', text: '2 days', value: '48'},
	{key: '72', text: '3 days', value: '72'},
	{key: '96', text: '4 days', value: '96'},
	{key: '120', text: '5 days', value: '120'},
	{key: '144', text: '6 days', value: '144'},
	{key: '168', text: '7 days', value: '168'}
];
export const OPTION_THIRD_EMAIL_SENDOUT_DELAY = [
	{key: '3', text: '3 hours', value: '3'},
	{key: '4', text: '4 hours', value: '4'},
	{key: '8', text: '8 hours', value: '8'},
	{key: '12', text: '12 hours', value: '12'},
	{key: '24', text: '1 day', value: '24'},
	{key: '36', text: '1.5 days', value: '36'},
	{key: '48', text: '2 days', value: '48'},
	{key: '72', text: '3 days (Recommended)', value: '72'},
	{key: '96', text: '4 days', value: '96'},
	{key: '120', text: '5 days', value: '120'},
	{key: '144', text: '6 days', value: '144'},
	{key: '168', text: '7 days', value: '168'}
];

/* dashboard-page */
export const GET_TEMPLATE_CONNECTION_STATISTICS = 'GET_TEMPLATE_CONNECTION_STATISTICS';
export const ERROR_TEMPLATE_CONNECTION_STATISTICS = 'ERROR_TEMPLATE_CONNECTION_STATISTICS';

/* whitelabel-page */
export const SEND_PAYMENT = 'SEND_PAYMENT';
export const ERROR_SEND_PAYMENT = 'ERROR_SEND_PAYMENT';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const ERROR_PRODUCTS = 'ERROR_PRODUCTS';

/* dashboard-checkout-page */
export const GET_CHECKOUTS = 'GET_CHECKOUTS';
export const ERROR_GET_CHECKOUTS = 'ERROR_GET_CHECKOUTS';

/* payments-page */
export const GET_PAYMENTS = 'GET_PAYMENTS';
export const ERROR_GET_PAYMENTS = 'ERROR_GET_PAYMENTS';

/* callback-payment-page */
export const ACTIVATE_PAYMENT = 'ACTIVATE_PAYMENT';
export const ERROR_ACTIVATE_PAYMENT = 'ERROR_ACTIVATE_PAYMENT';



// WEBPACK FOOTER //
// ./src/constants/index.js